import {
  MovingStatus,
  PackageInfo,
  PackageInfoForm,
  PackType,
} from './../types/index'

type MakeDefaultPackageInfoProp = {
  movingStatus?: MovingStatus
  packType?: PackType
}
export const makeDefaultPackageInfo = ({
  movingStatus = 'ANIMATED',
  packType = 'PLUS',
}: MakeDefaultPackageInfoProp): PackageInfo => ({
  objectId: '',
  createdAt: new Date().toString(),
  updatedAt: new Date().toString(),
  thumbnail: {
    __type: 'file',
    url: '',
    name: '',
  },
  name: {
    en: '',
  },
  textLang: packType === 'PLUS' ? 'IMAGE_ONLY' : null,
  description: {
    en: '',
  },
  movingStatus,
  keyTexts: [],
  packType,
  status: 'creating',
})

export const makeDefaultPostPackageInfo = ({
  movingStatus = 'ANIMATED',
  packType = 'PLUS',
}: MakeDefaultPackageInfoProp): PackageInfoForm => ({
  name: {
    en: '',
  },
  textLang: packType === 'PLUS' ? 'IMAGE_ONLY' : undefined,
  description: {
    en: '',
  },
  movingStatus,
  keyTexts: [],
  packType,
})
